module.exports = __webpack_public_path__ + "static/media/Persian_gaussian2.cf5aa55a.png";